import React, { useState } from 'react'
import styled from 'styled-components'

import { themeEstra } from 'app/styles/themeEstra'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'

import { globalSettings } from 'app/globalSettings'
import NewsletterForm from './NewsletterForm'
import NewsletterModal from './NewsletterModal'

import facebookLogo from 'static/icons/footer/facebook.svg'
// import dieciAnniEstraLogo from 'static/icons/footer/10_anni_estra_ok.svg'
import appStoreLogo from 'static/icons/footer/app_store_footer.svg'
import efMagazineLogo from 'static/icons/footer/ef_magazine.svg'
import googlePlayLogo from 'static/icons/footer/google_play_footer.svg'
import instagramLogo from 'static/icons/footer/instagram.svg'
import linkedinLogo from 'static/icons/footer/linkedin.svg'

export const Footer: React.FC = () => {
  const {
    facebookUrl,
    instagramUrl,
    linkedinUrl,
    appAndroidUrl,
    appIosUrl,
  } = globalSettings

  const [newsletterEmailValue, setNewsletterEmailValue] = useState('')
  const [showNewsletterModal, setShowNewsletterModal] = useState(false)

  return (
    <Wrapper>
      <Wave viewBox='0 0 1440 55' preserveAspectRatio='none'>
        <path
          d='M1098.67 12.7416C1265 7.5 1380.14 14.6193 1440 27.383V55H0V10.7416C9.23389 10.7416 90.5 0 154.5 0C476.534 0 541.156 27.383 741.5 27.383C881.988 27.383 895.689 19.1385 1098.67 12.7416Z'
          fill='#606876'
        />
      </Wave>

      <Container>
        <Top>
          <NewsletterCol>
            <Title>Iscriviti alla Newsletter</Title>
            <p>
              <em>
                Parliamo di futuro via email solo una volta al mese per amici e
                clienti. No spam, promesso :)
              </em>
            </p>

            <NewsletterFormContainer>
              <NewsletterForm
                onConfirm={emailValue => {
                  setNewsletterEmailValue(emailValue)
                  setShowNewsletterModal(true)
                }}
              />
              <NewsletterModal
                initialEmailValue={newsletterEmailValue}
                isVisible={showNewsletterModal}
                onToggle={setShowNewsletterModal}
              />
            </NewsletterFormContainer>
          </NewsletterCol>
          <SocialCol>
            <Title>Vediamoci anche sui social</Title>
            <p>
              <em>
                Sei come noi e ti piace girare per i social? Ti aspettiamo.
              </em>
            </p>

            <SocialList>
              <li>
                <a href={facebookUrl} target='_blank' rel='noopener noreferrer'>
                  <img src={facebookLogo} alt='facebook' />
                </a>
              </li>
              <li>
                <a
                  href='https://www.estra.it/ef-magazine/indice/tutti'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={efMagazineLogo} alt='ef magazine' />
                </a>
              </li>
              <li>
                <a href={linkedinUrl} target='_blank' rel='noopener noreferrer'>
                  <img src={linkedinLogo} alt='linkedIn' />
                </a>
              </li>
              <li>
                <a
                  href={instagramUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={instagramLogo} alt='instagram' />
                </a>
              </li>
            </SocialList>
          </SocialCol>
          <AppCol>
            <Title>La nostra app per i clienti</Title>
            <p>
              <em>
                Il futuro è mobile ed è lì che stiamo andando anche noi. Vieni
                anche tu?
              </em>
            </p>
            <AppList>
              <li>
                <a href={appIosUrl} target='_blank' rel='noopener noreferrer'>
                  <img src={appStoreLogo} alt='app IoS' />
                </a>
              </li>
              <li>
                <a
                  href={appAndroidUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={googlePlayLogo} alt='app android' />
                </a>
              </li>
            </AppList>
          </AppCol>
        </Top>
      </Container>
      <Divider />

      {/* <About>
        <AboutContent>
          <img src={dieciAnniEstraLogo} alt='10 anni Estra' />
          <p>
            Siamo una multiutility interamente pubblica nata nel Centro Italia:
            le persone e le comunità sono la nostra energia, è insieme a loro
            che cresciamo e costruiamo un futuro sostenibile. A loro dedichiamo
            tutta la nostra cura. Noi siamo Estra.
          </p>
        </AboutContent>
      </About> */}
      <Container>
        <Copy>
          <div>
            Estra S.p.A. - P. Iva 02149060978 - R.E.A. 505831 - Capitale sociale
            € 228.334.000,00 i.v. <br />
            Società soggetta ad attività di direzione e coordinamento da parte
            di PLURES S.P.A.
          </div>
          <Text variant='s14'>
            <a href='https://www.estra.it/informativa-cookies'>
              Informativa Cookies
            </a>{' '}
            |{' '}
            <a href='https://www.estra.it/informativa-cookies'>
              Privacy policy e copyright
            </a>
          </Text>
        </Copy>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${props => props.theme.color.primari.grigioEstra};
  color: #fff;
  position: relative;

  a {
    color: #fff;
    :hover {
      opacity: 0.8 !important;
      color: #fff;
    }
  }
`

const Wave = styled.svg`
  position: absolute;
  bottom: 99.99999%;
  left: 0;
  right: 0;
  width: auto;
  height: auto;
  margin-top: 10px;
  margin-bottom: -1px;
`

const Top = styled.div`
  padding: 2.5rem 0;
  display: grid;
  grid-gap: 3rem;

  @media (min-width: ${themeEstra.bp.tablet}) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 3rem 2rem;
  }

  @media (min-width: ${themeEstra.bp.desktop}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 4.5rem;
  }
`

const NewsletterCol = styled.div`
  @media (min-width: ${themeEstra.bp.tablet}) {
    grid-column: 1 / 3;
  }
  @media (min-width: ${themeEstra.bp.desktop}) {
    grid-column: auto;
  }
`
const SocialCol = styled.div``
const AppCol = styled.div``

const Title = styled.h3`
  text-transform: uppercase;
  font-size: 0.7rem;
  margin-bottom: 0.7rem;
  letter-spacing: 0.1em;
`

const NewsletterFormContainer = styled.div`
  margin-top: 1rem;
`

const SocialList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 0px;
  > li {
    display: inline-block;
    padding-right: 2rem;
    padding-top: 0.3125rem;
  }
`

const AppList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 0px;
  > li {
    display: inline-block;
    padding-right: 0.625rem;
    padding-bottom: 0.3125rem;
  }
`

const Divider = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

// const About = styled.div`
//   background-color: ${themeEstra.body.bg};
//   color: ${themeEstra.color.primari.grigioEstra};
// `

// const AboutContent = styled.div`
//   max-width: 730px;
//   margin: auto;
//   display: grid;
//   grid-template-columns: 63px auto;
//   padding: 2.125rem 1rem;
//   grid-gap: 2rem;
//   img {
//     margin: auto;
//   }
// `

const Copy = styled.div`
  padding: 2rem 0;
  @media (min-width: ${themeEstra.bp.desktop}) {
    display: flex;
    justify-content: space-between;
    /* Account for chat icon */
    padding-right: 70px;
  }
  @media (min-width: 1400px) {
    padding-right: 0;
  }
`
